import { DataTableActionConfiguration } from '../../model'
import { EnumTipoLoteLiquidacion } from '../../api/oData/enums/enumTipoLoteLiquidacion'
import { ObjectionTableModel } from '../invoicesPage/invoicesPage.Model'

export enum EnumSettlementTableCustomActionConfig {
  NOT_DEFINED = 0,
  CUSTOM_SELECTION = 1,
  VIEW_OBJECTIONS = 2,
  ERROR_SETTLEMENT = 3
}

export interface GlobalObjectionTableModel extends ObjectionTableModel {
  type?: string[] // EnumTipoLoteLiquidacion como chip; vacío para objeciones de ejecución sin lote
  executionDate?: string
  source?: string // 'SettlementBatch' | 'ExecutionCycle'
  executionCycleID?: number
  domain?: number
  actionsConfiguration?: Array<DataTableActionConfiguration>
  actions?: any
}

export enum EnumSettlementBatchMode {
  INVOICE_ALL = 1,
  INVOICE_WITHOUT_OBJECTIONS = 2,
  INVOICE_WITH_OBJECTIONS = 3,
  INVOICE_CUSTOM_SELECTION = 4,
  ISSUE_ALL = 5,
  ISSUE_WITH_OBJECTIONS = 6,
  ISSUE_WITH_DATE_RANGE = 7,
  ISSUE_CUSTOM_SELECTION = 8,
  ISSUE_WITHOUT_OBJECTIONS = 9,
  REGENERATE_INVOICES = 10,
  REJECT_INVOICES = 11,
  ANNULATE_CUSTOM_SELECTION = 12,
  REPAINT_INVOICES = 13,
  BULK_LOAD = 14,
  DELETE_ERROR_SETTLEMENTS = 15
}

export enum EnumSettlementSearchType {
  Contract = 'contract',
  CUPS = 'cups',
  Subject = 'subject',
  Trade = 'trade',
  Product = 'product',
  InvoiceCode = 'invoiceCode'
}

export interface SettlementFormSearchFilter {
  searchType: EnumSettlementSearchType
  searchValue: string
  hasObjections?: boolean
  lowQualityBad?: boolean
  // Advanced filters
  hasInvoiceObjections?: boolean
  hasNotInvoiceObjections?: boolean
  invoiceState?: number
  masterObjectionId?: number
  amountFrom?: number
  amountTo?: number
  issueDateFrom?: string
  issueDateTo?: string
  subjectSubtype?: number
  contractType?: number
}

export interface ClosedSettlementsSearchRequest {
  // Mandatory
  startDate: string
  endDate: string
  // Basic optional filters (derived from searchType + searchValue in FE)
  invoiceCode?: string
  contractCode?: string
  cupsCode?: string
  subjectName?: string
  lowQualityBad?: boolean
  maxResults?: number
  // Advanced optional filters
  hasInvoiceObjections?: boolean // true=con objeciones, false=sin, undefined=sin filtro
  masterObjectionId?: number
  invoiceState?: number // EnumEstadoFactura
  amountFrom?: number
  amountTo?: number
  issueDateFrom?: string // "YYYY-MM-DD"
  issueDateTo?: string // "YYYY-MM-DD"
  subjectSubtype?: number // EnumSubtipoSujeto
  contractType?: number // EnumTipoContrato
}

export interface SettlementSearchRequestModel {
  executionCycleId: number
  invoiceCycleType: number
  subjectType: number
  billingType: number
  cycleState: number
  objCode?: string
  notIssued?: boolean // true (filtra != emitidas), false (filtra solo emitidas), undefined (no filtra)
  contractCode?: string
  cupsCode?: string
  subjectName?: string
  tradeCode?: string
  productCode?: string
  invoiceCode?: string
  hasObjections?: boolean
  lowQualityBad?: boolean
  maxResults?: number
  // Advanced filters - Settlement dates
  masterObjectionId?: number
  startDateFrom?: string
  startDateTo?: string
  endDateFrom?: string
  endDateTo?: string
  settlementState?: number
  // Advanced filters - Invoice specific
  hasInvoiceObjections?: boolean
  invoiceState?: number
  amountFrom?: number
  amountTo?: number
  issueDateFrom?: string
  issueDateTo?: string
  subjectSubtype?: number
  contractType?: number
}

export interface SettlementsStateValidationRequestModel {
  executionCycleId: number
  settlementIds: number[]
  expectedState: number // EnumEstadoLiquidacion
}

export interface DropzoneDialogInvoiceForm {
  operationType: EnumTipoLoteLiquidacion
}

// ---------------------------------------------------------------------------
// Adjustment Concepts Search (Refacturación por Ajustes / LG_GENERAR_FACTURA = 0)
// ---------------------------------------------------------------------------

export interface AdjustmentConceptSearchRequestModel {
  // Mandatory
  executionCycleId: number
  maxResults?: number

  // Basic search fields (derivados de searchType + searchValue en el FE)
  contractCode?: string
  cupsCode?: string
  invoiceCode?: string // Código factura origen
  conceptCode?: string // Código concepto
  settlementGroupCode?: string

  // Advanced filters — Concepto
  conceptState?: number // EnumEstadoFactura
  amountFrom?: number
  amountTo?: number
  startDateFrom?: string // Fecha desde concepto — "YYYY-MM-DD"
  startDateTo?: string
  endDateFrom?: string // Fecha hasta concepto — "YYYY-MM-DD"
  endDateTo?: string

  // Advanced filters — Factura origen
  issueDateFrom?: string // Fecha emisión factura origen — "YYYY-MM-DD"
  issueDateTo?: string
  hasObjections?: boolean // true=con objeciones, false=sin, undefined=sin filtro
}

export enum EnumTipoOperacionMasivaCiclos {
  Emision = EnumTipoLoteLiquidacion.Emision,
  Regenerar = EnumTipoLoteLiquidacion.Facturacion,
  Repintado = EnumTipoLoteLiquidacion.Repintado
}

export interface RegenerateFormData {
  startDate?: string
  endDate?: string
  invoiceCycleSubtype?: number
}
